module.exports = __webpack_public_path__ + "img/hair.be5030ca.webp";